export class LastSearch {
  searchText: string;
  searchProperty: string;


  constructor() {
  }

  /**
   * Getter searchText
   * @return {string}
   */
  public getSearchText(): string {
    return this.searchText;
  }

  /**
   * Setter searchText
   * @param {string} value
   */
  public setSearchText(value: string) {
    this.searchText = value;
  }

  /**
   * Getter searchProperty
   * @return {string}
   */
  public getSearchProperty(): string {
    return this.searchProperty;
  }

  /**
   * Setter searchProperty
   * @param {string} value
   */
  public setSearchProperty(value: string) {
    this.searchProperty = value;
  }


}


// WEBPACK FOOTER //
// ./src/app/shared/model/last-search.ts